import styled from 'styled-components';
import SliderComponent from 'react-slick';
import { Box, Flex } from '@latitude/box';
import { Heading5 } from '@latitude/heading';
import {
  ALIGN,
  ALIGN_CONTENT,
  BREAKPOINT,
  COLOR,
  MARGIN,
  PADDING,
  REBRAND_COLOR
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const FeatureSliderOuterWrapper = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : REBRAND_COLOR.WHITE};
`;

export const FeatureSliderInnerWrapper = styled(Section)`
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  p {
    margin: 0;
  }
`;

export const Card = styled(Flex)`
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;
  align-items: ${props =>
    props.align === ALIGN.LEFT
      ? `${ALIGN_CONTENT.FLEX_START}`
      : `${ALIGN_CONTENT.CENTER}`};
  padding-right: 40px;
  &.white-tiles {
    background-color: ${COLOR.WHITE};
    padding: 14px;
    height: 100%;
  }

  @media (max-width: ${BREAKPOINT.SM}) {
    flex-direction: ${props => (props.align === ALIGN.LEFT ? 'row' : 'column')};
    gap: 16px;
    padding-right: 0px;
  }
`;

export const CardIcon = styled(Flex)`
  width: 48px !important;
  height: 48px !important;
  margin-bottom: 0px;
  @media (min-width: ${BREAKPOINT.MD}) {
    margin-bottom: 16px;
  }
`;

export const CardText = styled(Flex)`
  flex-direction: column;
  flex-basis: fit-content;
  @media (max-width: ${BREAKPOINT.SM}) {
    margin: 0 0 15px 0;
  }
`;

export const CardHeading = styled(Heading5)`
  width: 100%;
  text-align: ${props => `${props.align}`};
  color: ${COLOR.BLACK};
  margin-bottom: ${MARGIN.M16};
  @media (max-width: ${BREAKPOINT.SM}) {
    margin-bottom: 0;
  }
`;

export const CardBody = styled(Box)`
  width: 100%;
  margin: 16px 0;
  a {
    color: ${REBRAND_COLOR.MID_BLUE};
    text-decoration: none;
    border-bottom: 1px solid ${REBRAND_COLOR.MID_BLUE};
    &:hover {
      text-shadow: none;
      border-color: ${REBRAND_COLOR.MID_BLUE};
    }
  }
  ul {
    margin: 0px;
    padding-left: 20px;
  }
`;

export const Slider = styled(SliderComponent)`
  display: block;
  position: relative;
  box-sizing: border-box;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  margin-top: 32px;

  &.slick-initialized {
    .slick-slide {
      display: block;
    }
  }

  .slick-list {
    display: block;
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0;
    transform: translate3d(0, 0, 0);
    &:focus,
    &:active {
      outline: 0;
    }
  }

  .slick-track {
    display: flex;
    align-items: stretch;
    position: relative;
    top: 0;
    left: 0;
    transform: translate3d(0, 0, 0);

    :after {
      content: '';
      display: table;
      clear: both;
    }

    :before {
      content: '';
      display: table;
    }
    @media (max-width: ${BREAKPOINT.SM}) {
      flex-direction: column;
    }
  }

  .slick-slide {
    display: none;
    float: left;
    min-height: 1px;
    padding: 0;
    cursor: grab;
    :focus,
    :active {
      outline: 0;
    }
    & > div {
      height: 100%;
    }
    @media (max-width: ${BREAKPOINT.SM}) {
      width: 100% !important;
    }
  }

  .slick-loading {
    .slick-slide,
    .slick-track {
      visibility: hidden;
    }
  }

  .slick-dots li button:before {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    background-color: ${REBRAND_COLOR.STONE};
    border-radius: 50%;
    opacity: 1;
  }

  /* ACTIVE DOT → RECTANGLE */
  .slick-dots li.slick-active button:before {
    width: 24px;
    height: 12px;
    background-color: ${REBRAND_COLOR.GREEN};
    border-radius: 32px;
  }

  .slick-dots li.slick-active {
    margin-right: 16px;
  }
`;
